import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgFor } from '@angular/common';

@Component({
  selector: 'it-body-editor',
  standalone: true,
  templateUrl: './it-body-editor.component.html',
  styleUrls: ['./it-body-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor],
})
export class ItBodyEditorComponent {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  @ViewChild('bodyTa', { static: true }) bodyTa!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('ln', { static: true }) ln!: ElementRef<HTMLElement>;

  bodyLineNumbers: number[] = [1];

  ngOnChanges(): void {
    this.updateBodyLineNumbers(this.value);
  }

  onInput(v: string): void {
    const next = (v ?? '').toString();
    this.valueChange.emit(next);
    this.updateBodyLineNumbers(next);
    queueMicrotask(() => this.syncBodyScroll());
  }

  syncBodyScroll(): void {
    const ta = this.bodyTa?.nativeElement;
    const ln = this.ln?.nativeElement;
    if (!ta || !ln) return;
    ln.scrollTop = ta.scrollTop;
  }

  private updateBodyLineNumbers(text: string | null | undefined): void {
    const t = (text ?? '').toString();
    const lines = t.length ? t.split('\n').length : 1;
    this.bodyLineNumbers = Array.from({ length: Math.max(1, lines) }, (_, i) => i + 1);
  }
}
